import { IModelAdapter, Tag } from 'shell-models-lib';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
/**
 * Transforms a Tag entity back and forth between resource and model representations.
 */
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(Tag)
})
/* eslint-disable @typescript-eslint/no-explicit-any */
export class TagAdapter implements IModelAdapter<Tag, any[]> {
    public toResource(named: Tag): any {
        let tag: any;
        if (named.value) {
            tag = named.value;
        }
        return tag as any;
    }
    public toModel(resource: any): Tag {
        return new Tag(resource);
    }
    public async postToModel(value: Tag): Promise<void> {
        return;
    }
}
